
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { Task } from 'types'

export const getTaskById = async (pk: string, sk: string): Promise<Task | undefined> => {
  try {
    const url = `${baseUrl}/aws/tasks/${encodeURIComponent(pk)}/${encodeURIComponent(sk)}`
    const response = await axios.get(url, {
      params: { table: 'TASKS_TABLE' },
    })

    if (response.status === 204 || !response.data) {
      return undefined
    }

    return response.data as Task
  } catch (error) {
    console.error('Error fetching task:', error)
    return undefined // ✅ consistent return type
  }
}

export const useTask = (pk: string, sk: string) => {
  const { data: task, isLoading: isTaskLoading, isError: isTaskError }: UseQueryResult<Task | undefined> = useQuery({
    queryKey: ['task', pk, sk],
    queryFn: () => getTaskById(pk!, sk!),
    enabled: !!pk && !!sk,
    staleTime: Infinity,
    gcTime: 1000 * 60 * 10,
  })

  return {
    task,
    isTaskLoading,
    isTaskError,
  }
}
